import {Dialog, Menu} from "@mui/material"
import MenuItem from "@mui/material/MenuItem"
import React, {Dispatch, SetStateAction, useCallback, useContext, useRef, useState} from "react"
import {BackendContext} from "../../../context/BackendContext"
import {ProfileContext} from "../../../context/Profile.context"
import {notifyUpdate} from "../../../functions/ipfs-orbit"
import {IssueDB} from "../../../models/IssueDB.model"
import styles from "./index.module.scss"
import {v4 as uuidv4} from "uuid"

interface NewOrEditIssueProps {
  open: boolean,
  onClose: () => void,
  db: IssueDB,
  dbReplCnt: number,
  setDBReplCnt: Dispatch<SetStateAction<number>>,
  isNew: boolean,
  title?: string,
  description?: string
  issueId?: string
}

export const NewOrEditIssue = (props: NewOrEditIssueProps) => {
  const {db, onClose, setDBReplCnt, isNew} = props
  // Relevant to existing issue only
  const {title, description, issueId} = props
  const {ipfs} = useContext(BackendContext)
  const {profile, profileReplCnt} = useContext(ProfileContext)
  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false)
  const anchorEl = useRef<HTMLButtonElement>(null)
  const summaryRef = useRef<HTMLInputElement>(null)
  const descriptionRef = useRef<HTMLTextAreaElement>(null)

  const onCloseMenu = useCallback(() => {
    setIsOpenMenu(false)
  }, [])

  const onClickSubmit = useCallback(async () => {
    console.log("DEBUG: onClickSubmit begins")

    if (!ipfs || !profile || profileReplCnt === undefined) {
      return
    }

    const summary = summaryRef.current?.value
    const description = descriptionRef.current?.value
    if (!summary || !description) {
      return
    }

    await db.load()

    if (isNew) {
      const requestId = uuidv4()
      await db.put(
        requestId,
        {
          id: requestId,
          title: summary,
          description,
          status: "open",
          authorName: profile.get("name"),
          authorProfileAddress: profile.address.toString(),
          createAt: Date.now()
        }
      )
    } else {
      if (!issueId) {
        return
      }
      const issue = db.get(issueId)
      issue.title = summary
      issue.description = description
      await db.put(issueId, issue)
    }

    await notifyUpdate(ipfs, db.address.toString())

    setDBReplCnt(prevCnt => prevCnt + 1)
    onClose()

    console.log("DEBUG: onClickSubmit ends")
  }, [summaryRef, descriptionRef, db, ipfs, profile, profileReplCnt, onClose, setDBReplCnt,
    isNew, issueId])

  const onClickCancel = useCallback(() => {
    onClose()
  }, [onClose])

  return (
    <Dialog open={props.open}
            onClose={props.onClose}
            PaperProps={{className: styles.NewIssueDialog}}
    >
      {
        isNew
          ?
          <div className={styles.NewIssueDialogHeader}>
            Create a new issue
          </div>
          :
          <div className={styles.NewIssueDialogHeader}>
            Edit issue
          </div>
      }

      <div className={styles.InputFormHeader}>
        Summary
      </div>

      <input ref={summaryRef} className={styles.SummaryInputForm} defaultValue={title}/>

      <div className={styles.InputFormHeader}>
        Description
      </div>

      <textarea ref={descriptionRef}
                className={styles.DescriptionInputForm}
                defaultValue={description}
      />

      <div className={styles.BtnGroup}>
        <button className={styles.CancelBtn} onClick={onClickCancel}>
          Cancel
        </button>
        <button className={styles.SubmitBtn} onClick={onClickSubmit}>
          Submit
        </button>
      </div>

      <Menu
        anchorEl={anchorEl.current}
        open={isOpenMenu}
        onClose={onCloseMenu}
      >
        <MenuItem className={styles.TypeSelectorItem}>
          Feature request
        </MenuItem>
        <MenuItem className={styles.TypeSelectorItem}>
          Bug fix
        </MenuItem>
      </Menu>

    </Dialog>
  )
}
